
import TextalignJustifyleft from "../../../assets/duotone/TextalignJustifyleft.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function TextalignJustifyleftIcon({ className, dataTestid = "TextalignJustifyleftIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <TextalignJustifyleft data-testid={dataTestid} className={classes} {...rest} />
  );
}
